import React from "react"

import { Box } from "@mui/material"
import { AppLegendItem } from "@components"
import { useReportBackendApiPath } from "Pages/ReportsAlerts/Reports/@hooks"
import { selectedReportTypeTab } from "Pages/ReportsAlerts/Reports/@signals"
import { REPORT_TYPE_TABS } from "Pages/ReportsAlerts/Reports/@constants"


export default function ReportIconsLegend() {
	const { reportType } = useReportBackendApiPath()
	const isRating = selectedReportTypeTab.value === REPORT_TYPE_TABS.RATING
	const isOneWay = selectedReportTypeTab.value === REPORT_TYPE_TABS.ONE_WAYS

	const legend = [{
		icon: "arrow-right-arrow-left",
		label: "One Way Analyzer",
		props: {
			iconProps: { color: "success.dark" },
			containerProps: { color: "success.dark" },
		},
		condition: isOneWay,
	}, {
		icon: "clock-rotate-left",
		label: "View in real time historical",
		condition: isOneWay,
	}, {
		icon: "tally",
		label: "LOR Analyzer",
		condition: !reportType && !isRating && !isOneWay,
	}, {
		icon: "calendar-days",
		label: "DOR Analyzer",
		props: {
			iconProps: { color: "info.main" },
			containerProps: { color: "info.main" },
		},
		condition: !reportType && !isRating && !isOneWay,
	}, {
		icon: "handshake",
		label: "Brokers Analyzer",
		props: {
			iconProps: { color: "warning.main" },
			containerProps: { color: "warning.main" },
		},
		condition: !reportType && !isRating && !isOneWay,
	}, {
		icon: "chart-line",
		label: "Direct Site",
		props: {
			iconProps: { color: "success.main" },
			containerProps: { color: "success.dark" },
		},
		condition: !reportType && !isRating && !isOneWay,
	}, {
		icon: "ranking-star",
		label: "Position Analyzer",
		props: {
			iconProps: { color: "secondary.main" },
			containerProps: { color: "secondary.main" },
		},
		condition: !reportType && !isRating && !isOneWay,
	}, {
		icon: "star",
		label: "Rating analyzer",
		props: {
			iconProps: { color: "warning.main" },
			containerProps: { color: "warning.main" },
		},
		condition: (!reportType || isRating) && !isOneWay,
	}, {
		icon: "cloud-arrow-down",
		label: "Download Report",
		props: {
			iconProps: { color: "success.main" },
			containerProps: { color: "success.dark" },
		},
		condition: !isRating,
	}, {
		icon: "file-arrow-down",
		label: "Download Export",
		props: {
			iconProps: { color: "primary.main" },
			containerProps: { color: "primary.main" },
		},
		condition: !isRating,
	}, {
		icon: "cloud-arrow-down",
		label: "Download multi-report",
		props: {
			iconProps: { color: "colors.pink" },
			containerProps: { color: "colors.pink" }
		},
		// one way reports generate their own workbook now, and the icon already renders
		// for them, so the legend has to explain it
		condition: true,
	}, {
		icon: "file-arrow-down", label: "Download multi-export", props: {
			iconProps: { color: "colors.deepPurple" },
			containerProps: { color: "colors.deepPurple" }
		},
		condition: !isRating && !isOneWay,
	}]

	return <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
		<Box sx={{ display: "flex", justifyContent: "center", alignItems: "space-around", m: 0 }}>
			{legend.map((item, idx) => {
				return !item.condition
					? null
					: <AppLegendItem
						icon={item.icon}
						label={item.label}
						key={`${idx}-${item.label}`}
						{...item?.props}/>
			})}
		</Box>
	</Box>
}